import '../utils/extends';
import log from 'loglevel';
import Browser from './../utils/Browser';

/**
 * @description 用来模拟消息收发的 函数类
 * @export
 * @class SimulateMsgService
 * @author zhenliang.sun
 */
export default class SimulateMsgService {
  constructor(cbk = null) {
    this.cbk = cbk;
    this.store = null;
  }

  /**
   * @description 模拟消息发送
   * @param {*} msg
   * @memberof SimulateMsgService
   */
  send(msg) {
    let str = JSON.stringify(msg);
    let isSDK = this.store.getKV('isMobileSDK') || false;
    // 如果是安卓 或者 是鸿蒙
    if ((Browser.isAndroid || Browser.isHarmony) && isSDK) {
      try {
        window.doodlesdk.toServer(str);
      } catch (error) {
        log.error(error);
      }
      return;
    }

    // 如果是iOS
    if (Browser.isIOS && isSDK) {
      // SKWebView
      try {
        window.webkit.messageHandlers.toServer.postMessage(str);
      } catch (error) {
        log.error(error);
      }
      return;
    }

    // 剩下的就是web了
    let d = new Date().toLogDate();
    log.info(`[sim] send ${d} ${str}`);
    if (this.cbk) {
      this.cbk(str);
    }
  }

  sendEventToMobile(act, data) {
    let obj = {
      type: act,
      info: data
    };

    let msgStr = JSON.stringify(obj);
    let isSDK = this.store.getKV('isMobileSDK') || false;
    // 如果是安卓 或者 是鸿蒙
    if ((Browser.isAndroid || Browser.isHarmony) && isSDK) {
      try {
        window.doodlesdk.toServerEvent(msgStr);
      } catch (error) {
        log.error(error);
      }
    }

    // 如果是iOS
    if (Browser.isIOS && isSDK) {
      try {
        window.webkit.messageHandlers.toServerEvent.postMessage(msgStr);
      } catch (error) {
        log.error(error);
      }
    }
  }
}
